export default "<app-toolbar-menus [routes]=\"routes\" [text]=\"text\" (itemclicked)=\"propagate($event)\"></app-toolbar-menus>"